import moment from 'moment'
import _ from 'lodash'

const baseController = {
  extends: {
    delimiters: ['[[', ']]']
  },

  filters: {
    time(x) {
      return moment(x).format('LT')
    },
    date(x) {
      return moment(x).format('LL')
    },
    dateTime(x) {
      return moment(x).format('DD/MM/YYYY HH:mm')
    },
    calendar(x) {
      return moment(x).calendar(null, { sameElse: 'DD/MM/YYYY' })
    },
    calendarShortFormat(x) {
      return moment(x).calendar(moment(), {
        lastDay: 'LT [(-1d)',
        sameDay: 'LT',
        nextDay: 'LT [(+1d)]',
        lastWeek: 'lll',
        nextWeek: 'lll',
        sameElse: 'lll'
      })
    },
    toInt(x) {
      if (x) return x.toFixed()
    }
  },

  methods: {
    navigate(url) {
      if (document.location.pathname !== url) {
        return (document.location.pathname = url)
      }
    },

    parseUrl(url) {
      const patternParts = url.split('/').slice(1)
      const parts = document.location.pathname.split('/').slice(1)
      const data = {}
      for (let [pattern, part] of _.zip(patternParts, parts)) {
        if (pattern[0] === ':') {
          data[pattern.slice(1)] = part
        } else if (pattern !== part) {
          return null
        }
      }
      return data
    },

    parseQueryString(qstring = window.location.search) {
      qstring = qstring.substr(1).split('&')
      const results = {}
      for (let param of qstring) {
        let [key, value] = param.split('=')
        if (key) {
          if (value === undefined || value === null) {
            value = true
          } else {
            value = decodeURIComponent(value.replace(/\+/g, ' '))
          }
          results[key] = value
        }
      }
      return results
    }
  }
}

export default baseController
